import styled from 'styled-components/native';
import style, { hpx, wpx } from './../../styles/index';

export const Container = styled.View`
  padding: ${hpx(20)} ${wpx(20)};
  width: 100%;
  border-top-width: 1px;
  border-top-color: #f0f0f0;
  background-color: white;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  elevation: 10;
  box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.05);
`;

export const AddButton = styled.TouchableOpacity`
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  background-color: ${props => props.theme.colors.primary};
  flex: 1;
  margin-left: ${wpx(15)};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${hpx(14)} ${wpx(20)};
  border-radius: 8px;
  height: ${hpx(50)};
`;

export const AddButtonText = styled.Text`
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
  color: ${style.colors.white};
`;

export const QuantityContainer = styled.View`
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: ${wpx(110)};
  height: ${hpx(50)};
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 ${wpx(5)};
`;

export const MinusButtonText = styled.Text`
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.xxlarge};
  color: ${props => props.theme.colors.primary};
  padding: 0 ${wpx(10)};
`;

export const PlusButtonText = styled.Text`
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.xxlarge};
  color: ${props => props.theme.colors.primary};
  padding: 0 ${wpx(10)};
`;

export const ItemCount = styled.Text`
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.medium};
  color: #333;
`;
